import { html } from "lit";
var icon_activation_default = () => html`
  <svg viewBox="0 0 21 22" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.587.817a2.055 2.055 0 012.262.046 2.086 2.086 0 01.865 2.105l-3.14 16.835a2.06 2.06 0 01-3.685.864l-1.33-1.788-2.284 1.57c-.584.4-1.328.47-1.972.196l-.158-.076a2.084 2.084 0 01-1.101-1.84l-.001-3.921-4.475.001a2.07 2.07 0 01-1.892-1.24l-.06-.153-.036-.115a2.09 2.09 0 01.892-2.34L17.587.817zm1.912 1.59L10.61 14.19l4.265 5.732c.176.237.461.36.749.332l.107-.018a.834.834 0 00.63-.662l3.14-16.836a.832.832 0 00-.003-.33l.001-.001zM9.53 14.81H8.277v3.92c0 .283.141.544.372.699l.072.043a.832.832 0 00.86-.049l2.237-1.537L9.53 14.81zm.003-1.242l8.885-11.782a.898.898 0 00-.177.085L2.125 12.015a.844.844 0 00-.36.944c.103.36.43.608.803.608h6.965v.001z" />
  </svg>
`;
export {
  icon_activation_default as default
};
//# sourceMappingURL=icon-activation.js.map
